import React from 'react';
import CodeEditorPanel from "./CodeEditorPanel";
import CodeOptionTreeEditor from "./CodeOptionTreeEditor";

function CommonCodeEditor({
    item,
    setItem,
    onSave,
    onDelete,
    onCreateOption,
    onUpdateOption,
    onDeleteOption,
}) {
    return (
        <div className="common-code-editor">
            <div className="common-code-editor__info">
                <CodeEditorPanel
                    category="common"
                    item={item}
                    setItem={setItem}
                    onSave={onSave}
                    onDelete={onDelete}
                    nameLabel="코드명"
                    viewMode
                />
            </div>
            <div className="common-code-editor__options">
                <CodeOptionTreeEditor
                    parentId={item.id}
                    options={item.children ?? []}
                    onCreate={onCreateOption}
                    onUpdate={onUpdateOption}
                    onDelete={onDeleteOption}
                />
            </div>
        </div>
    );
}

export default CommonCodeEditor;
